document.addEventListener('DOMContentLoaded', () => {

    // period
    const periodBtns = document.querySelectorAll('.period-btn');
    periodBtns.forEach(btn => {
        btn.addEventListener('mouseover', () => {
            periodBtns.forEach(b => b.classList.remove('active'));
            btn.classList.add('active');
        });
    });

    // dropdown
    const filters = document.querySelectorAll('.filter-box');
    filters.forEach(box => {
        const btn = box.querySelector('.filter-btn');
        const dropdown = box.querySelector('.dropdown');

        // 鈿狅笍 闃叉鍏冪礌涓嶅瓨鍦ㄦ椂鎶ラ敊
        if (!btn || !dropdown) return;

        btn.addEventListener('click', e => {
            e.stopPropagation(); // 馃敶 寰堥噸瑕侊細闃叉琚?document.click 绔嬪埢鍏抽棴

            filters.forEach(b => {
                if (b !== box) {
                    b.classList.remove('open');
                    const d = b.querySelector('.dropdown');
                    if (d) d.style.display = 'none';
                }
            });

            const open = box.classList.toggle('open');
            dropdown.style.display = open ? 'block' : 'none';
        });
    });

    document.addEventListener('click', e => {
        if (!e.target.closest('.filter-box')) {
            filters.forEach(b => {
                b.classList.remove('open');
                const d = b.querySelector('.dropdown');
                if (d) d.style.display = 'none';
            });
        }
    });

});